export default "__VITE_ASSET__CDzxN$XZ__"